import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "bfx-order-details-ccy-selector",
  templateUrl: "./html/bfx-order-details-ccy-selector.html",
  standalone: false,
})
export class BfxOrderDetailsCcySelectorComponent implements OnInit {
  @Output() onPairChange: EventEmitter<any> = new EventEmitter();

  @Input() model: Set<string>;
  @Input() activeItem: string;

  public currencyPairIds: Set<string> = new Set<string>();
  public current: string;
  public active: boolean = false;

  constructor() {}

  ngOnInit() {
    this.current = this.activeItem;
  }

  public onSelectPair(pair: string) {
    this.current = pair;
    this.onPairChange.emit(pair);
  }
}
